import type {UpdateMaterialCompositionFormPayload} from "./update-material-composition.schema";

import {updateMaterialComposition} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {materialKeys, materialMutationKeys} from "../../../../../material-keys";

export function updateMaterialCompositionMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: materialMutationKeys.updateMaterialComposition,
    mutationFn: (payload: UpdateMaterialCompositionFormPayload) =>
      updateMaterialComposition(id, payload),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: materialKeys.detail(id)}),
        client.invalidateQueries({queryKey: materialKeys.lists()}),
      ]);
    },
  });
}
